var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("v-text-field", {
        attrs: {
          color: "secondary",
          label: _vm.$t("global.password"),
          "append-icon": _vm.show ? "mdi-eye" : "mdi-eye-off",
          rules: _vm.rules.password,
          type: _vm.show ? "text" : "password",
          name: "password",
          hint: _vm.$t("register.min-password-security")
        },
        on: {
          "click:append": function($event) {
            _vm.show = !_vm.show
          }
        },
        model: {
          value: _vm.password,
          callback: function($$v) {
            _vm.password = $$v
          },
          expression: "password"
        }
      }),
      _c(
        "v-expand-transition",
        [
          _c("v-text-field", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isPasswordValid,
                expression: "isPasswordValid"
              }
            ],
            attrs: {
              id: "confirmPassword",
              color: "secondary",
              label: _vm.$t("register.confirm-password"),
              "append-icon": _vm.showConfirmEye ? "mdi-eye" : "mdi-eye-off",
              rules: [_vm.matchPassword],
              type: _vm.showConfirmEye ? "text" : "password",
              name: "confirmPassword"
            },
            on: {
              "click:append": function($event) {
                _vm.showConfirmEye = !_vm.showConfirmEye
              }
            },
            model: {
              value: _vm.confirmPassword,
              callback: function($$v) {
                _vm.confirmPassword = $$v
              },
              expression: "confirmPassword"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }